import React from "react";

import { Container, Row, Col } from "react-bootstrap";

import Jumbo from "./Jumbo";
import ServiceForm from "./ServiceForm";
import EmailSendingImage from "../assets/img/Email.svg";
const pageName = "Contact Us";
const message = "Awesome things are created when we work together.";

const ContactUsPage = () => {
  return (
    <div>
      <Jumbo pageName={pageName} message={message}></Jumbo>
      <Container className="main-section-contact">
        <Row>
          <Col xs={12} md={6}>
            <img src={EmailSendingImage} alt="email" />
          </Col>
          <Col xs={12} md={6}>
            <div className="contact-quotes">
              <h1>Feel free to reach</h1>

              <br />
              <p>
                worked with some of the who’s who of the business world too. Our
                headquarters is centrally located in Bhubaneswar, Odisha, India.
              </p>
            </div>
          </Col>
        </Row>
        <hr />
      </Container>
      <div className="form-section-contact">
        <Container className="main-section-contact">
          <Row>
            <Col xs={12} md={6}>
              <div className="contact-quotes">
                <h1>Request for Service.</h1>
                <p>
                  Find out more about how we can help your organization break
                  the thought barriers
                </p>
              </div>
            </Col>
            <Col xs={12} md={6}>
              <ServiceForm />
            </Col>
          </Row>
          <hr />
        </Container>
      </div>
    </div>
  );
};

export default ContactUsPage;
